<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <ts-page-title
                :title="$t('bankProfile.pageTitle')"
                :breadcrumb="[
                    { text: $t('home'), href: '/' },
                    {
                        text: $t('bankProfile.pageTitle'),
                        href: '/admin/bank-profiles'
                    },
                    { text: $t('edit'), active: true }
                ]"
            />
            <div class="demo-spin-article">
                <ts-panel>
                    <ts-panel-wrapper>
                        <form-input v-model="model" :validate="errors" />
                    </ts-panel-wrapper>
                </ts-panel>
            </div>
        </vue-custom-scrollbar>

        <Spin size="large" fix v-if="loading"></Spin>

        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'bank-profile' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}
            </ts-button>
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting"
                @click.prevent="onSave"
            >
                {{ $t("save") }}
            </ts-button>
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import { isEmpty } from "lodash";
import FormInput from "./components/form-input.vue";

export default {
    name: "BankProfileEdit",
    components: { FormInput },
    data() {
        return {
            loading: false,
            waiting: false,
            errors: new Errors(),
            model: {
                bank_id: null,
                bank_name: "",
                accounts: []
            }
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    computed: {
        ...mapState("finance/bankProfile", ["edit_data"])
    },
    methods: {
        ...mapActions("finance/bankProfile", ["find"]),
        async fetchFormData() {
            this.loading = true;
            await this.find(this.$route.params.id);
            this.setEditData();
            this.loading = false;
        },
        setEditData() {
            if (!isEmpty(this.edit_data)) {
                this.model = {
                    bank_id: this.edit_data.bank_id,
                    bank_name: this.edit_data.bank_name || "",
                    accounts: (this.edit_data.accounts || []).map(a => ({
                        account_id: a.account_id,
                        employee_id: a.employee_id || null,
                        employee: a.employee || null,
                        account_no: a.account_no,
                        account_name: a.account_name,
                        qr_image: a.qr_image || null,
                        is_receive_cash_transfer: !!a.is_receive_cash_transfer
                    }))
                };
            }
        },
        onSave() {
            this.errors = new Errors();
            this.waiting = true;
            this.$store
                .dispatch("finance/bankProfile/update", {
                    id: this.model.bank_id,
                    data: this.model
                })
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                    if (response.message_id == 0) {
                        this.$store.commit("finance/bankProfile/RESET_STATE");
                        this.$router.push({ name: "bank-profile" });
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors);
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => (this.waiting = false));
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "BANK PROFILE",
                desc: not.text
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.fetchFormData());
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        this.$store.commit("finance/bankProfile/RESET_STATE");
        next();
    }
};
</script>
